import { SlotsToClasses } from "@nextui-org/react";
import { cn } from "@/libs/utils/tailwind/cn";

export default function NavLink({
  href,
  children,
  onClick,
  variant = "default",
  classNames,
}: NavLinkProps) {
  return (
    <a
      href={href}
      className={cn(
        "font-normal !text-primary !no-underline m-0",
        VARIANT_CLASS_NAMES[variant],
        classNames?.base
      )}
      onClick={onClick}
    >
      {children}
    </a>
  );
}

interface NavLinkProps {
  href: string;
  children: React.ReactNode;
  onClick?: () => void;
  variant?: keyof typeof VARIANT_CLASS_NAMES;
  classNames?: SlotsToClasses<"base">;
}

const VARIANT_CLASS_NAMES = {
  default: "p-4 py-1 text-xl",
  nested: "py-1 text-base",
} as const;
